import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortDto } from "app/models";
import { TeamService } from "app/services";

@Component({
    selector: 'team-short-modal',
    templateUrl: './team-short.modal.html',
    styleUrls: ['./team-short.modal.scss'],
})
export class TeamShortModal implements OnInit {
    @Input() team: TeamShortDto;

    teamId: number;

    constructor(public activeModal: NgbActiveModal, private teamService: TeamService) {
    }
    
    ngOnInit(): void {
        this.teamId = this.team?.id;
    }

    loadTeam() {
        if (this.teamId) {
            this.teamService.getShortTeam(this.teamId)
                .subscribe(result => {
                    this.team = result;
                })
        }
    }

    onSubmit() {
        if (this.teamId) {
            this.activeModal.close(this.team);
        }
    }
}